export default (targetScroll, duration = 400) => {
  const currentScroll = window.scrollY || document.documentElement.scrollTop;
  const distance = targetScroll - currentScroll;

  const startTime = performance.now();

  const step = () => {
    let normalizedTime = (performance.now() - startTime) / duration;
    if (normalizedTime > 1) normalizedTime = 1;

    window.scrollTo(0, currentScroll + distance * Math.sin((normalizedTime * Math.PI) / 2));
    if (normalizedTime < 1) {
      window.requestAnimationFrame(step);
    }
  };

  window.requestAnimationFrame(step);
};
